import { Popover } from '@mui/material';
import { useState } from 'react';

import PlusIcon from '../../../assets/svg/PlusIcon';

export const DialOutcomeDetails = ({ label, options }) => {
  const [anchorEl, setAnchorEl] = useState(null);

  const onOpenPopover = e => {
    setAnchorEl(e.currentTarget);
  };

  const onClosePopover = () => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <>
      <button
        onClick={onOpenPopover}
        className="w-[18px] h-[18px] rounded-full border border-brand-300/30 outline-none flex justify-center items-center"
      >
        <PlusIcon className="w-3 h-3 text-brand-500" />
      </button>
      <Popover
        open={open}
        slotProps={{
          paper: {
            className:
              '!rounded-lg -mt-3 !shadow-[0_4px_20px_0_rgba(17,17,58,0.08)] bg-white w-[220px]',
          },
        }}
        anchorEl={anchorEl}
        onClose={onClosePopover}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'center',
        }}
        transformOrigin={{
          vertical: 'bottom',
          horizontal: 'center',
        }}
      >
        <div className="flex flex-col gap-2.5 px-3 py-2.5">
          <span className="text-[14px]/[150%] font-semibold text-base-1000">
            {label}
          </span>
          <div className="flex flex-col gap-2">
            {options.map(({ value, label }, idx) => (
              <div
                key={idx}
                className="flex items-center justify-between gap-2"
              >
                <span className="text-[12px]/[16px] text-base-800 text-nowrap">
                  {label}
                </span>
                <span className="text-[14px]/[16px] font-medium text-base-1000 truncate">
                  {value}
                </span>
              </div>
            ))}
          </div>
        </div>
      </Popover>
    </>
  );
};
